import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  isOverTop: boolean
  isOverBottom: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '-16px',

    '& > :nth-child(2)': {
      marginBottom: '-1rem'
    }
  },

  row: {
    display: 'flex'
  },

  drag: {
    marginRight: '0.5rem',
    cursor: 'grab'
  },

  emptyDrag: {
    marginRight: '0.5rem',
    width: '16px'
  },

  dropContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '1rem'
  },

  drop: {
    width: '100%',
    height: '0.25rem !important'
  },

  dropTop: {
    background: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },

  dropBottom: {
    background: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  },

  bold: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '& > div': {},

    '& > :first-child': {
      marginBottom: '0.25rem'
    }
  },

  warning: {
    color: theme.palette.indicator.red
  }
}))

export default useStyles
